import React from 'react';

export type StatusDotVariant = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

const variantClasses: Record<StatusDotVariant, string> = {
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
  neutral: 'bg-faint',
  info: 'bg-accent',
};

interface StatusDotProps {
  variant: StatusDotVariant;
  size?: 'sm' | 'md' | 'lg';
  title?: string;
  pulse?: boolean;
  className?: string;
}

const sizeClasses = {
  sm: 'w-1.5 h-1.5',
  md: 'w-2.5 h-2.5',
  lg: 'w-3 h-3',
};

export const StatusDot: React.FC<StatusDotProps> = ({ variant, size = 'md', title, pulse, className = '' }) => (
  <span
    data-variant={variant}
    className={`inline-block rounded-full ${variantClasses[variant]} ${sizeClasses[size]} ${pulse ? 'animate-pulse' : ''} ${className}`}
    title={title}
    role={title ? 'img' : undefined}
    aria-label={title}
  />
);
